import gql from "graphql-tag";

export const DELETE_ONE_TELEGRAM_MENU_BUTTON = gql`
  mutation ($id: ID!) {
    deleteOneTelegramMenuButton(input: { id: $id }) {
      id
    }
  }
`;
